import type { BackupScope, BackupSource } from '@/types/api';

/**
 * The scope a backup of this source can actually have.
 *
 * A source with only a database has no files for a full backup to take, and one with only a
 * directory has nothing for a database-only backup to contain; the API refuses both. So when a source
 * leaves no choice, the choice is made here and the picker shows it rather than offering one the
 * save would refuse.
 */
export function scopeFor(source: BackupSource | undefined, chosen: BackupScope): BackupScope {
  if (source === undefined) return chosen;
  if (!source.has_directory) return 'database';
  if (!source.has_database) return 'full';
  return chosen;
}
